import React, { useEffect, useRef } from 'react'

import Box from '../Box'
import DropdownContext from './DropdownContext'
import DropdownToggle from './DropdownToggle'
import DropdownContent from './DropdownContent'
import DropdownItem from './DropdownItem'

import useDisclosure from '../../hooks/useDisclosure'
import { useOnClickOutside } from '../../hooks'
import { isUndefined } from '../../utils/locDash'

import { DropdownProps } from './Dropdown.types'

const Dropdown: React.FC<DropdownProps> = ({
  children,
  onBlur,
  onOpen,
  trigger = 'click',
  control,
  ...restProps
}) => {
  const dropdownRef = useRef<HTMLDivElement | null>(null)

  const {
    isOpen: show,
    onToggle,
    onClose,
    onOpen: onShow,
  } = control || useDisclosure({ open: false })

  useOnClickOutside(dropdownRef, onClose)

  useEffect(() => {
    if (show && !isUndefined(onOpen)) {
      return onOpen()
    }
    if (!show && !isUndefined(onBlur)) {
      return onBlur()
    }
  }, [show])

  const providerValue = {
    show,
    trigger,
    onToggle,
    onBlur,
    onOpen,
    onClose,
    onShow,
  }

  const onMouseLeave = () => {
    if (trigger !== 'hover') return

    onClose()
  }

  return (
    <DropdownContext.Provider value={providerValue}>
      <Box
        position='relative'
        width='fit-content'
        aria-label='box-dropdown'
        ref={dropdownRef}
        onMouseLeave={onMouseLeave}
        {...restProps}
      >
        {children}
      </Box>
    </DropdownContext.Provider>
  )
}

export default Object.assign(Dropdown, {
  Toggle: DropdownToggle,
  Content: DropdownContent,
  Item: DropdownItem,
})
